import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header cursor-pointer px-9" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Información de la Empresa")
], -1)
const _hoisted_4 = { class: "card-body p-9" }
const _hoisted_5 = { class: "row mb-7" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Rut de Empresa", -1)
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_9 = { class: "row mb-7" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Nombre de Empresa", -1)
const _hoisted_11 = { class: "col-lg-8 fv-row" }
const _hoisted_12 = { class: "fw-bold fs-6" }
const _hoisted_13 = { class: "row mb-7" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, [
  /*#__PURE__*/_createTextVNode(" Nombre de Contacto "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Corresponde al nombre del usuario asociado a la cuenta"
  })
], -1)
const _hoisted_15 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_16 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_17 = { class: "row mb-7" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Teléfono Contacto", -1)
const _hoisted_19 = { class: "col-lg-8" }
const _hoisted_20 = {
  href: "#",
  class: "fw-bold fs-6 text-dark text-hover-primary"
}
const _hoisted_21 = { class: "row mb-7" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, [
  /*#__PURE__*/_createTextVNode(" Email Contacto "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "A este correo nos contactaremos"
  })
], -1)
const _hoisted_23 = { class: "col-lg-8" }
const _hoisted_24 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_25 = { class: "row mb-7" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Banco ", -1)
const _hoisted_27 = { class: "col-lg-8" }
const _hoisted_28 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_29 = { class: "row mb-7" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Tipo Cuenta ", -1)
const _hoisted_31 = { class: "col-lg-8" }
const _hoisted_32 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_33 = { class: "row mb-7" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Número Cuenta ", -1)
const _hoisted_35 = { class: "col-lg-8" }
const _hoisted_36 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_37 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6"
}
const _hoisted_38 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_39 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_40 = { class: "fw-bold" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, " Necesitamos su atención! ", -1)
const _hoisted_42 = { class: "fs-6 text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: { name: 'profile-settings' },
        class: "btn btn-melon align-self-center px-6"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Modificar Información")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.currentProveedor.rutProveedor), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.currentProveedor.nombreProveedor), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.currentContacto.nombres) + " " + _toDisplayString(_ctx.currentContacto.apellidos), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.currentContacto.telefono), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.currentContacto.email), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.currentProveedor.nombreBanco), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.currentProveedor.tipoCuenta), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.currentProveedor.numeroCuenta), 1)
        ])
      ]),
      (_ctx.currentProveedor.bloqueado == 'S')
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("span", _hoisted_38, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _createTextVNode(" Su cuenta se encuentra bloqueada o con observaciones. Esto puede generar que sus documentos no sean pagados. "),
                  _createVNode(_component_router_link, {
                    class: "fw-bolder",
                    to: { name: 'apps-tickets-getting-started' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Consulta el motivo")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(". ")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}